// extracted by mini-css-extract-plugin
export default {"unauthorized":"_2iOBGOi8qgnw3VghM5GrTm"};